import Form from '@submize/form';
import { useSchema } from '../../../helpers/schema';

const Design = () => {
  const schema = useSchema();
  return (
    <Form onSubmit={() => {}} schema={schema.schema} />
  );
};
export default Design;
